import { useContext } from "react"
import { AuthProvider } from "../components/Auth/AuthProvider"

export function useAuth() {
  const baseValue = useContext(AuthProvider.authContext)

  if (!baseValue) {
    throw new Error("useAuth must be used within an AuthProvider")
  }

  return baseValue
}
